const prefix = "share/";
export const _sharedActionsConstantsShare = {
  SET_SHARE_DATA: prefix + "SET_SHARE_DATA",
};

export const _sharedActionsShare = {
  setShareData: (shareData) => ({
    type: _sharedActionsConstantsShare.SET_SHARE_DATA,
    data: shareData,
  }),
};
